import { HttpClient } from './httpClient';
import { API_URL } from './RestAPI';
import apiHeaders from './apiHeaders';

const REPORT_API = `${API_URL}/reports`;

const getSalesByProduct = (startDate, endDate) => {
  return HttpClient.get(
    `${REPORT_API}/sales-by-product?startDate=${startDate}&endDate=${endDate}`,
    apiHeaders()
  );
};

const getProductBuyers = (variantId, startDate, endDate) => {
  return HttpClient.get(
    `${REPORT_API}/sales-by-product/${variantId}/buyers?startDate=${startDate}&endDate=${endDate}`,
    apiHeaders()
  );
};

const StoreReportApi = { getSalesByProduct, getProductBuyers };

export { StoreReportApi };